import React, { useState, useEffect } from "react";
import CheckBoxes from "./CheckBoxesObj";

function CheckBoxesObjExample(props) {
  // location data from server
  const [checkBoxAnswer, setCheckBoxAnswer] = useState();
  let i = 0;
  const [locationDD, setLocationDD] = useState([]);
  const [locationSelected, setLocationSelected] = useState();

  useEffect(() => {

    init();
    return () => console.log("you left! unmounting...");
  }, []); // <-- empty array here make it only rnu once

  function init() {


    // get location array objects for dropdown
    fetch("/reactexample/rest/utils/get/dropdown", {mode:"no-cors"})
      .then((res) => res.json())
      .then((result) => {
        setLocationDD(
          // result.map((item) => ({
          //   value: item.id,
          //   label: item.name,
          //   selected: item.id === locationID ? true : false // compare it.
          // }))
          result
        );
        // find the selected location ID, setup the value in dropdown
        //setLocationSelected();
        //result.filter((item) => item.id == locationID)[0].id.toString()

      })
      .catch((error) => {
        console.error("Error:", error);
      });

    // get single object for selected
    fetch("/reactexample/rest/utils/get/dropdown", {mode:"no-cors"})
      .then((response) => response.json())
      .then((result) => {
    
        setLocationSelected(result[0]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

//    // get location array objects for dropdown
//    fetch("https://bc3rg2.csb.app/data/checkboxes.json")
//      .then((res) => res.json())
//      .then((result) => {
//        setLocationDD(result);
//        // find the selected location ID, setup the value in dropdown
//        //setLocationSelected();

//      })
//      .catch((error) => {
//        console.error("Error:", error);
//      });
//
//    // get single object for selected
//    fetch("https://bc3rg2.csb.app/data/checkboxes_selected.json")
//      .then((response) => response.json())
//      .then((result) => {

//        setLocationSelected(result);
//      })
//      .catch((error) => {
//        console.error("Error:", error);
//      });
  }
  return (
    <div>
      <CheckBoxes
        id={"check_boxes_" + i++}
        label="Check Boxes"
        name="checkboxes1"
        data={locationDD}
        selectedItem={locationSelected}
        isRequired={true}
        layoutVertical={false}
        //helpMessage={""}
        // update formik values, and react
        // return object e, include 3 parts,
        //   e.e = current event, formik need this
        //   e.count = number of selected items, use for formik values
        //   e.ary = checkboxes array object, use for normal return value
        value={(selectedItems) => {
          //values.checkboxes1 =
          //  e.count; /* formik will test # of selected item */
          setCheckBoxAnswer(selectedItems); // return value to array object

        }}
        onChange={(selectedItems) => {
          //handleChange(e.e); // return event to formik
          setCheckBoxAnswer(selectedItems); // return value to array object
          setLocationSelected(selectedItems); // update the selected checkbox

        }}
        onBlur={(selectedItems) => {
          //handleBlur(e); // return event to formik
          //validateForm(); // force run validation onBlur
          setCheckBoxAnswer(selectedItems); // return value to array object

        }}
        // this two controled by formik
        //hasError={touched.checkboxes1 && errors.checkboxes1}
        //errorMessage={errors.checkboxes1}
        // on forcus, change touched to true
        onFocus={(trueFalse) => {
          // touch even for formik, return true/false value
          //touched.checkboxes1 = e;

        }}
      />
      <span>
        selected {checkBoxAnswer !== undefined ? checkBoxAnswer.length : "-"}{" "}
        item
        {checkBoxAnswer !== undefined && checkBoxAnswer.length > 1 ? "s" : ""}
        <br />
        {checkBoxAnswer !== undefined ? JSON.stringify(checkBoxAnswer) : "-"}.
      </span>
    </div>
  );
}

export default CheckBoxesObjExample;
